/**
 * The header by which a request **names** the school it is acting under.
 *
 * It carries a **tenant id** — the same value `/v1/me` returns — and it is a
 * selection among the grants the caller's verified token already proves, never
 * an assertion of tenancy
 * ([ADR-0049](../../../docs/decisions/0049-a-request-names-its-school-the-token-proves-the-grant.md)).
 * A school the token holds no grant at is refused with `NO_GRANT_AT_SCHOOL`.
 *
 * Distinct from `X-Tenant-Id`, which remains **not a security input anywhere**
 * ([ADR-0017](../../../docs/decisions/0017-every-service-verifies-the-token.md)) and
 * which nothing reads. The names are deliberately different so that the two can
 * never be confused in a client, a proxy config or a log.
 *
 * Omit it and a caller granted exactly one school acts there, which is every
 * caller today.
 */
export const SCHOOL_HEADER = 'x-rythmo-school';
//# sourceMappingURL=identity.js.map